// @core/api/endpoints/chat/unpin_message.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/chat';

/**
 * Unpin a message
 * Removes a message from the pinned messages list. The message itself is not deleted and remains in the conversation history.
 */
export async function UnpinMessage(
  conversation_id: string,
  message_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id/pin`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
